export function timezoneOffset() {
  return (new Date).getTimezoneOffset();
}

export function startOfToday() {
  return timezoneOffset() < 0 ? moment().utc().startOf('day') : moment().startOf('day').utc();
}

export function resetTimezone(date){
  var offset = new Date().getTimezoneOffset();
  var dateTimestamp = Date.parse(date);
  var dateUtcTimestamp = dateTimestamp - (offset * 60 * 1000);
  var dateUtcDate = new Date(dateUtcTimestamp);
  return dateUtcDate;
}

export function getDateRanges() {
  return {
    today: [
      new Date(),
      new Date()
    ],
    yesterday: [
      new Date(new Date().setDate(new Date().getDate() - 1)),
      new Date(new Date().setDate(new Date().getDate() - 1))
    ],
    last7Days: [
      new Date(new Date().setDate(new Date().getDate() - 6)),
      new Date()
    ],
    last30Days: [
      new Date(new Date().setDate(new Date().getDate() - 29)),
      new Date()
    ],
    thisMonth: [
      new Date(new Date().setDate(1)),
      new Date()
    ],
    lastMonth: [
      new Date(new Date(new Date().setDate(0)).setDate(1)),
      new Date(new Date().getFullYear(), new Date().getMonth(), 0)
    ]
  };
};

export function isSameDay(date1, date2) {
  return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}

export function getDateRangeName(startDate, endDate) {
  if (!startDate && !endDate)
    return undefined;

  return _.findKey(getDateRanges(), function (range) {
    return isSameDay(range[0], startDate) && isSameDay(range[1], endDate);
  });
}

export function normalizeTimeframe(timeframe) {
  timeframe = timeframe || {
    rangeName: 'last30Days',
    comparisonStartDate: null,
    comparisonEndDate: null,
    granularity: 'days'
  };
  timeframe.startDate = new Date(timeframe.startDate);
  timeframe.endDate = new Date(timeframe.endDate);
  let range = getDateRanges()[timeframe.rangeName];
  if (range) {
    timeframe.startDate = range[0];
    timeframe.endDate = range[1];
  }

  return timeframe;
}



/** WEBPACK FOOTER **
 ** ./src/common/datetime/date-ranges.js
 **/